"use client";

import dynamic from "next/dynamic";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const HeaderSearch = dynamic(() => import( /* webpackChunkName: "HeaderSearch" */"components/modals/search-bar-model"));
const HeaderSearchPill = () => {
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  if (!isLargerThan992) {
    return null;
  }
  return <HeaderSearch data-sentry-element="HeaderSearch" data-sentry-component="HeaderSearchPill" data-sentry-source-file="HeaderSearchPill.tsx" />;
};
export default HeaderSearchPill;